import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Driver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: `driverMaster`, readItems: { driverLeft: '0' } })
      .then(async(dataArray) => {
        if(dataArray?.data?.resultSet?.length){
          for(let data of dataArray.data.resultSet){
            if(data.driverLicense) data.driverLicense = await aesDecrypt(data.driverLicense);
            if(data.panNo) data.panNo = await aesDecrypt(data.panNo);
            if(data.aadharNo) data.aadharNo = await aesDecrypt(data.aadharNo);
          }
          this.setState({
            rowData: dataArray.data.resultSet,
            loadingData: false,
          });
        }else{
          this.setState({
            rowData: [],
            loadingData: false,
          });

        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-driver", {
      ...rowData,
      title: "Edit Driver",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/driver");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const headerChange = () => {
      if (localStorage.getItem('customerNumber') == 1158) {
        return t("table_header.partner") || "Partner"
      } else {
        return t("table_header.vendor") || "Vendor"
      }
    }
    const Columns = [
      {
        headerName: t("table_header.driver_name") || "Driver Name",
        field: "driverName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.license_number") || "License Number",
        field: "driverLicense",
        sortable: true,
        filter: true,
      },
      {
        headerName: `${headerChange()}`,
        field: "vendorName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.mobile_number") || "Mobile Number",
        field: "driverContact",
        sortable: true,
        filter: true,
        hide: true,
      },
      {
        headerName: t("table_header.sim_card_provider") || "Sim Card Provider",
        field: "serviceProvider",
        sortable: true,
        filter: true,
        hide: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_DRIVER_MASTER.UPDATE && !this.props.permissions.TA_DRIVER_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={this.props.t("title") || "Drivers"}
          titleBarLink={"/add-driver"}
          baseURL={"driverMaster"}
          pathName={'driverMaster'}
          keyIndex={"driverMasterId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_DRIVER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_DRIVER_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("driver")(Driver));
